import React from 'react';
import { motion } from 'framer-motion';
export function SocialProof() {
  const stats = [{
    value: '+800',
    label: 'personas ya lo tienen'
  }, {
    value: '6',
    label: 'Tomos completos'
  }, {
    value: '6',
    label: 'Bonos incluidos'
  }, {
    value: '4.9/5',
    label: 'calificación ⭐'
  }];
  return <section className="py-10 border-y border-dark-border bg-dark-card/50" data-id="element-248">
      <div className="max-w-6xl mx-auto px-4" data-id="element-249">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-250">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="flex flex-col items-center justify-center" data-id="element-251">
              <span className="text-3xl md:text-4xl font-bold text-gold mb-2 font-heading" data-id="element-252">
                {stat.value}
              </span>
              <span className="text-sm md:text-base text-gray-300 font-medium" data-id="element-253">
                {stat.label}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}